// @flow
import * as React from 'react';
import {compose} from 'redux';

import Headliner from '../Headliner/Headliner';
import SeoContent from '../SeoContent/SeoContent';
import withSeoMetaData from '../withSeoMetaData/withSeoMetaData';

import type {WithSeoMetaDataProps} from '../withSeoMetaData/withSeoMetaData';
import type {SearchReviewSummary} from '../SearchReviews/SearchReviews';

import './PreFooter.less';

type OwnProps = {
    topRecentReviews?: SearchReviewSummary[]
};

type Props = WithSeoMetaDataProps & OwnProps;

const mapOwnPropsToSeoContentProps = ({
    topRecentReviews,
    seoData: {searchReviewsHeadline}
}: Props) =>
    topRecentReviews && topRecentReviews.length
        ? {searchReviewsHeadline, topRecentReviews}
        : null;

export default function PreFooter(props: Props) {
    const {headlineTitle} = props.seoData;
    const seoContentProps = mapOwnPropsToSeoContentProps(props);
    const shouldShowPreFooter = headlineTitle || !!seoContentProps;

    return (
        shouldShowPreFooter && (
            <div className="PreFooter bg-module-bg-color">
                <div
                    className={'PreFooter__headline PreFooter__section--padded'}
                >
                    {headlineTitle && <Headliner headline={headlineTitle} />}
                </div>
                {seoContentProps && (
                    <div
                        className={
                            'PreFooter__seoContent PreFooter__section--padded'
                        }
                    >
                        <SeoContent {...seoContentProps} />
                    </div>
                )}
            </div>
        )
    );
}

export const PreFooterWithSeoData = compose(withSeoMetaData)(PreFooter);
